function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_26912_10289)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 2.5C8.12845 2.50005 8.25376 2.53968 8.35888 2.61349C8.464 2.6873 8.54383 2.79171 8.5875 2.9125L13 15.045L14.9125 9.785C14.9566 9.66467 15.0366 9.56081 15.1417 9.48747C15.2468 9.41413 15.3719 9.37487 15.5 9.375H19.875C20.0408 9.375 20.1997 9.44085 20.3169 9.55806C20.4342 9.67527 20.5 9.83424 20.5 10C20.5 10.1658 20.4342 10.3247 20.3169 10.4419C20.1997 10.5592 20.0408 10.625 19.875 10.625H15.9375L13.5875 17.0875C13.5437 17.2082 13.4638 17.3124 13.3587 17.3861C13.2536 17.4597 13.1284 17.4993 13 17.4993C12.8716 17.4993 12.7464 17.4597 12.6413 17.3861C12.5362 17.3124 12.4563 17.2082 12.4125 17.0875L8 4.955L6.0875 10.2137C6.04362 10.3343 5.96371 10.4384 5.8586 10.512C5.7535 10.5856 5.6283 10.625 5.5 10.625H1.125C0.95924 10.625 0.800269 10.5592 0.683058 10.4419C0.565848 10.3247 0.5 10.1658 0.5 10C0.5 9.83424 0.565848 9.67527 0.683058 9.55806C0.800269 9.44085 0.95924 9.375 1.125 9.375H5.0625L7.4125 2.9125C7.45617 2.79171 7.536 2.6873 7.64112 2.61349C7.74624 2.53968 7.87155 2.50005 8 2.5Z",
  fill: "#23335B"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_26912_10289"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(0.5)"
})));

var SvgAnalytics = function SvgAnalytics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnalytics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/analytics.7a614a8c.svg";
export { ForwardRef as ReactComponent };